var render = function render(){var _vm=this,_c=_vm._self._c;return _c('woot-button',{attrs:{"size":"expanded","color-scheme":"primary","class-names":"submit--button","is-disabled":_vm.isDisabled,"is-loading":_vm.isLoading},on:{"click":_vm.onClick}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),_c('fluent-icon',{attrs:{"icon":_vm.icon,"size":"18"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }